export default "__VITE_ASSET__g4BOkbhc__"